import { useEffectOnce } from 'react-use'

export const useWindowScrollTop = (ms = 500) => {
	useEffectOnce(() => {
		setTimeout(() => {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		}, ms)
	})
}
